module.exports = __webpack_public_path__ + "img/login1.a198b412.jpg";